import { inject, Pipe, PipeTransform } from '@angular/core';
import { LookupFieldResult, LookupObject } from '@wdx/clmi/clmi-swagger-gen';
import { Avatar } from '@wdx/clmi/utils/models';
import { PartyToAvatarPipe } from '@wdx/clmi/utils/pipes';
import { map, Observable } from 'rxjs';
import { InfoCardService } from '../../../../services/info-card/info-card.service';

@Pipe({ name: 'asyncLookupAvatars' })
export class AsyncLookupAvatarsPipe implements PipeTransform {
    private infoCardService = inject(InfoCardService);

    transform(
        value:
            | LookupFieldResult
            | LookupObject
            | Array<LookupFieldResult | LookupObject>,
    ): Observable<Avatar[]> {
        return this.infoCardService.getLookups$(value).pipe(
            map((lookups) =>
                lookups
                    .map((value) => new PartyToAvatarPipe().transform(value))
                    .map((value) => ({
                        ...value,
                        isAvatarInfoEnabled: Boolean(
                            value.partyType || value.lookupType,
                        ),
                    })),
            ),
        );
    }
}
